import {Component, OnInit} from '@angular/core';
import {APP_CONFIG} from '@core-app/app.config';
import {ClientService} from '@core-app/services/client.service';

@Component({
    selector: 'core-footer',
    templateUrl: './footer.component.html',
    styles: [],
    standalone: false,
})
export class FooterComponent implements OnInit {
    copyright = APP_CONFIG.copyright;

    logoUrl!: string;
    currentYear: number = new Date().getFullYear();

    constructor(
        private client: ClientService
    ) {
    }

    ngOnInit() {
        this.logoUrl = this.client.getLogoURL();
    }

    getSiteName() {
        return this.client.getSiteName();
    }
}
